export const SECTION_TARGET = "section";
export const ADDRESS_TARGET = "address";
export const PROTECTION_TARGET = "protection";
export const PAYMENT_METHOD_TARGET = "payment_method";
export const BILLING_INFO_TARGET = "billing_info";
